import { format } from 'date-fns'

import {
  CALENDAR_GRID_LABEL_SEPARATOR,
  CalendarGridItemVariant,
} from '../../../../constants/calendarGrid'
import { DATE_API_DATA_FORMAT_SHORT } from '../../../../constants/date'
import { toUkTimezoneDate } from '../../../../utils/date'
import { CALENDAR_ITEM_KIND_VARIANT } from '../../Calendar.constants'
import { getIsCalendarAppointmentCancelled } from '../../Calendar.utils'

function getCalendarAppointmentAnchorLabel(anchor) {
  const anchorName = anchor.request?.number ?? anchor.building?.short_name

  return anchor.flat
    ? [anchorName, anchor.flat.name].join(CALENDAR_GRID_LABEL_SEPARATOR)
    : anchorName
}

function getCalendarLocalDate({ timezone, value }) {
  return format(toUkTimezoneDate(value, timezone), DATE_API_DATA_FORMAT_SHORT)
}

// TODO: open the appointment detail panel on click once it exists, instead of
// the grid card.
export function toCalendarGridAppointment({
  item: {
    anchor,
    end_at: end,
    id,
    is_all_day: isAllDay,
    kind,
    start_at: start,
    status,
    title,
  },
  timezone,
}) {
  return {
    date: getCalendarLocalDate({ timezone, value: start }),
    end,
    id,
    isAllDay,
    isArchived: anchor.is_archived,
    isCancelled: getIsCalendarAppointmentCancelled(status),
    isStatusPinned: true,
    kind,
    lastDate: getCalendarLocalDate({ timezone, value: end }),
    secondaryLabel: getCalendarAppointmentAnchorLabel(anchor),
    start,
    title,
    url: anchor.request?.url ?? anchor.building?.url,
    variant: anchor.is_archived
      ? CalendarGridItemVariant.muted
      : CALENDAR_ITEM_KIND_VARIANT[kind],
  }
}
